/* eslint-disable */
// ═══════════════════════════════════════════════════════════════════════════
// PAGE /catalogue — page autonome plein écran avec sidebar dédiée
// La logique CRUD est dans catalogue/CatalogueShared.js (réutilisée dans Admin > Paramètres)
// ═══════════════════════════════════════════════════════════════════════════
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

import {
  D, api, TABS,
  TabStatuts, TabTypes, TabSubTypes, TabGreffes, TabCabinets,
} from './catalogue/CatalogueShared';

export default function Catalogue() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('statuts');
  const [workspaces, setWorkspaces] = useState([]);

  // Guard admin
  useEffect(() => {
    if (user && user.role !== 'admin') navigate('/dashboard', { replace: true });
  }, [user, navigate]);

  // Charger la liste des workspaces pour les filtres
  useEffect(() => {
    api.get('/api/admin/workspaces').then(r => setWorkspaces(r.data || [])).catch(() => {});
  }, []);

  if (!user || user.role !== 'admin') return null;

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:D.bg, color:D.tx, fontFamily:"'DM Sans', sans-serif" }}>
      {/* Sidebar */}
      <div style={{ width:'188px', background:D.s1, borderRight:`1px solid ${D.b1}`, display:'flex', flexDirection:'column', flexShrink:0 }}>
        <div style={{ padding:'14px 16px', borderBottom:`1px solid ${D.b1}`, display:'flex', alignItems:'center', gap:'8px' }}>
          <span style={{ fontFamily:'Syne, sans-serif', fontSize:'15px', fontWeight:700, color:D.or }}>Lexback</span>
          <span style={{ fontSize:'9px', background:'rgba(212,168,67,0.15)', color:D.or, padding:'1px 6px', borderRadius:'3px', fontWeight:500 }}>CATALOGUE</span>
        </div>
        <nav style={{ flex:1, padding:'6px 0' }}>
          {TABS.map(tab => (
            <div key={tab.id} onClick={() => setActiveTab(tab.id)} style={{
              display:'flex', alignItems:'center', padding:'8px 16px', cursor:'pointer', fontSize:'12px',
              color: activeTab === tab.id ? D.or : D.tx2,
              borderLeft: activeTab === tab.id ? `2px solid ${D.or}` : '2px solid transparent',
              background: activeTab === tab.id ? 'rgba(212,168,67,0.06)' : 'transparent',
              transition:'all 0.12s',
            }}>
              <span style={{ flex:1 }}>{tab.label}</span>
            </div>
          ))}
          <div onClick={() => navigate('/admin')} style={{
            display:'flex', alignItems:'center', padding:'8px 16px', cursor:'pointer', fontSize:'12px',
            color: D.tx3, marginTop:'12px', borderTop:`1px solid ${D.b1}`,
          }}>
            <span style={{ flex:1 }}>← Retour Admin</span>
          </div>
        </nav>
        <div style={{ margin:'8px', background:D.s2, border:`1px solid ${D.b1}`, borderRadius:'8px', padding:'8px 10px' }}>
          <div style={{ fontSize:'11px', color:D.tx }}>{user?.prenom} {user?.nom}</div>
          <div style={{ fontSize:'9px', color:D.tx3 }}>Admin · Catalogue</div>
        </div>
      </div>

      {/* Main content */}
      <div style={{ flex:1, overflow:'auto', display:'flex', flexDirection:'column' }}>
        <div style={{ padding:'24px 28px' }}>
          <div style={{ marginBottom:'20px' }}>
            <h1 style={{ fontFamily:'Syne, sans-serif', fontSize:'20px', fontWeight:700, color:D.tx, margin:0 }}>
              Catalogue extensible
            </h1>
            <p style={{ fontSize:'12px', color:D.tx3, margin:'4px 0 0' }}>
              Gestion des référentiels : statuts, types de formalité, sous-types, greffes, cabinets.
            </p>
          </div>

          {activeTab === 'statuts'    && <TabStatuts workspaces={workspaces} />}
          {activeTab === 'types'      && <TabTypes workspaces={workspaces} />}
          {activeTab === 'sous-types' && <TabSubTypes workspaces={workspaces} />}
          {activeTab === 'greffes'    && <TabGreffes workspaces={workspaces} />}
          {activeTab === 'cabinets'   && <TabCabinets workspaces={workspaces} />}
        </div>
      </div>
    </div>
  );
}
